import Vue from 'vue';

export default function (selector) {
  const tabs = document.querySelectorAll(selector);
  const hashValue = window.location.hash.substr(1);

  if (!tabs.length) {
    return;
  }

  const initialTab = tabs[0].dataset.tab;

  const tabsSwitch = new Vue({
    name: 'tabs',
    el: '#js-tabs',
    delimiters: ['#{', '}'],
    data: {
      currentTab: initialTab,
    },
    methods: {
      goToTab: function (tab) {
        this.currentTab = tab;

        if (this.currentTab === 'clubPga') {
          if (!app.msnryPc) {
            return;
          }

          setTimeout(function () {
            app.msnryPc.rebuild();
          }, 50);
        }

        if (this.currentTab === 'messages') {
          if (!app.msnry) {
            return;
          }

          setTimeout(function () {
            app.msnry.rebuild();
          }, 50);
        }

        this.loaded = true;
      },
      goToChoosenOption: function (event) {
        this.goToTab(event.target.value);
      },
    },
    mounted: function () {
      const self = this;

      this.$nextTick(function () {
        if (hashValue !== '' && hashValue !== self.currentTab) {
          self.goToTab(hashValue);
        }
      });
    },
  });
};
